module.exports = __webpack_public_path__ + "img/py.13aa8d8.svg";